export default "__VITE_ASSET__c1aa2b69__"